import { useState, useEffect } from "react";
import { Alerts, GetSettings } from "../../../helpers";
import parse from 'html-react-parser';
const ExistingShippingZoneRates = ({ shipping_zone, handleCloseRateZone, getShippingZone }) => {
  const [isLoading, setLoading] = useState(true);
  const [shippingZoneRates, setShippingZoneRates] = useState([]);
  const [existingIds, setExistingIds] = useState([]);
  const getShippingZoneRates = async () => {
    const resp = await GetSettings.getAllShippingZoneRates();
    if (resp && resp.status) {
      setShippingZoneRates(resp.shipping_rates);
      setLoading(false);
    }
  };

  useEffect(() => {
    getShippingZoneRates();
    if(shipping_zone.shipping_zone_rates && shipping_zone.shipping_zone_rates.length > 0){
       const ids = shipping_zone.shipping_zone_rates.map((el)=>{
        return el.shipping_rate_id
       });
       setExistingIds(ids)
    }
  }, []);

   const handleCheckboxClick = async (zoneRateId) => {
    const data = {
      shippingZoneId:shipping_zone.id,
      shipping_rate_id:zoneRateId
    }
    const resp = await GetSettings.associateShippingZoneRates(data);
    if (resp && resp.status) {
           Alerts.alertMessage(resp.message, 'top-center', 'success');
           handleCloseRateZone();
           getShippingZone();
       }else{
           Alerts.alertMessage(resp.message, 'top-center', 'error');
       }

};
  return (
    <>
      {isLoading ? (
        <div className="loader">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      ) : (
        <>
        {
  shippingZoneRates && shippingZoneRates.length > 0 ? (
    <>
      {shippingZoneRates.map((zone_rate) => {
        const isSelected = existingIds.includes(zone_rate.id);

        return (
          <div
            key={zone_rate.id}
            className={`preview-box-inner border rounded bg-gray-100 ${
              isSelected ? "selected" : ""
            }`}
            style={{ padding: "15px 37px" }}
          >
            
            <div className="d-flex justify-content-between align-items-center">
              <div className="rate-check">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCheckboxClick(zone_rate.id)}
                />
              </div>
              <div>
                <div>{parse(zone_rate.shipping_rate_label.preview_label)}</div>
                {zone_rate.shipping_rate_type === "price"
                  ? `Price Range - (£${zone_rate.min_price} - £${zone_rate.max_price})`
                  : null}
                {zone_rate.shipping_rate_type === "weight"
                  ? `Weight Range - (${zone_rate.min_weight}kg - ${zone_rate.max_weight}kg)`
                  : null}
              </div>
              
            </div>

            <div className="price-tag">
              {parseFloat(zone_rate.price) > 0 ? (
                <div className="shipping-price">£ {zone_rate.price}</div>
              ) : (
                <span>Free</span>
              )}
            </div>
          </div>
        );
      })}
    </>
  ) : (
    <p className="rate-not-found">Rate not added !</p>
  )
}

        </>
      )}
    </>
  );
};

export default ExistingShippingZoneRates;
